import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import Icon from "@/components/icon";
import Text from "@/components/text";

interface PageHeaderProps {
  title: ReactNode;
  /** Shown beside the title (a status tag, a live marker). */
  meta?: ReactNode;
  description?: ReactNode;
  back?: { to: string; label: string };
  actions?: ReactNode;
}

export default function PageHeader({ title, meta, description, back, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-3">
      {back && (
        <Link to={back.to} className="inline-flex w-fit items-center gap-1 text-sm text-tg-link hover:text-tg-link/80">
          <Icon name="chevronLeft" size={16} />
          {back.label}
        </Link>
      )}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-3">
            <Text.Title className="truncate">{title}</Text.Title>
            {meta}
          </div>
          {description && <Text.Hint>{description}</Text.Hint>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
